import React, { useEffect } from 'react';
import { ToastContainer, Toast } from 'react-bootstrap';
import { useAppSelector, useAppDispatch } from "../../core/redux/hooks";

import { hideToaster } from '../../core/redux/toastSlice';

const ToastView = (props: any) => {
  let toastState = useAppSelector((state) => state.toast);
  const dispatch = useAppDispatch();
  const onDismissToast = () => {
    dispatch(hideToaster());
  };

  useEffect(() => {
    if (toastState.timer) {
      setTimeout(() => {
        onDismissToast();
      }, +toastState.timer);
    }
  }, [toastState]);

  return (
    <>  
    {(toastState.showDialog)?
        <ToastContainer className="position-fixed" position='bottom-center'>
            <Toast className={toastState.dialogBgColor} 
                style={{
                    position: 'relative',
                    marginBottom: 50
                }}>
                <div className='close' style={{marginRight: 10, marginTop: 5}} onClick={() => { onDismissToast() }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 22.628 22.627">
                        <g id="Close" transform="translate(-1261 -265)">
                        <rect id="Rectangle_1706" data-name="Rectangle 1706" width="4" height="28" rx="2" transform="translate(1280.799 265) rotate(45)" fill="#FFFFFF"/>
                        <rect id="Rectangle_1707" data-name="Rectangle 1707" width="4" height="28" rx="2" transform="translate(1261 267.828) rotate(-45)" fill="#FFFFFF"/>
                        </g>
                    </svg>
                </div>
                <Toast.Body className='text-white d-flex align-items-center'>
                    <div className='icon'></div>
                    <div className="text px-3" dangerouslySetInnerHTML={{ __html: toastState.dialogMsg }}></div>
                </Toast.Body>
            </Toast>
        </ToastContainer>
        : "" }
    </>
  );
}
export default ToastView;